export const AUDIT_PRICE_DOLLARS = 9;
export const AUDIT_PRICE_LABEL = '$9';
export const AUDIT_PRICE_CENTS = AUDIT_PRICE_DOLLARS * 100;
